import React from 'react';
import PageTemplate from '../PageTemplate';

const Greeting = () => {
  return (
    <PageTemplate
      title="📢 인사말"
      description="청소년 스마트폰 프리 운동본부 대표 인사말입니다"
    >
      <div>
        <h2>안녕하세요, 청소년 스마트폰 프리 운동본부입니다.</h2>
        <br />
        <p>
          디지털 기술의 발전과 함께 스마트폰은 우리 생활에 없어서는 안 될 필수품이 되었습니다. 
          하지만 과도한 스마트폰 사용으로 인한 부작용 또한 심각한 사회 문제로 대두되고 있습니다.
        </p>
        <br />
        <p>
          특히 청소년들의 스마트폰 과의존 문제는 학습 능력 저하, 사회성 부족, 신체 건강 악화 등 
          다양한 문제를 야기하고 있어 시급한 해결이 필요한 상황입니다.
        </p>
        <br />
        <p>
          청소년 스마트폰 프리 운동본부는 이러한 문제 인식을 바탕으로 건강한 디지털 문화 조성을 위해 
          설립되었습니다. 우리는 스마트폰을 완전히 배제하자는 것이 아니라, 
          올바르고 건전한 사용 문화를 만들어가고자 합니다.
        </p>
        <br />
        <p>
          교육, 캠페인, 연구 활동을 통해 청소년들이 스마트폰과 건강한 관계를 맺을 수 있도록 돕고, 
          학부모와 교육자들에게는 실질적인 가이드라인을 제공하겠습니다.
        </p>
        <br />
        <p>
          여러분의 관심과 참여가 건강한 디지털 사회를 만드는 첫걸음입니다. 
          함께 해주시기 바랍니다.
        </p>
        <br />
        <p style={{ textAlign: 'right', fontWeight: 'bold' }}>
          청소년 스마트폰 프리 운동본부 대표 일동
        </p>
      </div>
    </PageTemplate>
  );
};

export default Greeting; 